import { useNavigate, useParams } from 'react-router-dom';
import { Paper, Typography, IconButton, Container } from '@mui/material';
import { ArrowBack } from "@mui/icons-material";
import Grid from '@mui/material/Grid2';
import CercadorMovimentsGlobal from '../components/dashboard-anual/CercadorMovimentsGlobal.js';

const CercadorMovimentsGlobalPage = () => {
  const navigate = useNavigate();

  const { userapp: paramUserapp } = useParams();
  const userapp = paramUserapp;

  const gotoDashboard = () => {
    navigate(`/${userapp}`);
  };

  return (
    <Container>
      <Grid     
        size={{xs: 12, sm: 6 }} 
        sx={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '10px' }}
      >
        <IconButton onClick={() => gotoDashboard()}>
          <ArrowBack />
        </IconButton>

        <Typography variant="h5">
          Cercador de Moviments Global
        </Typography>
      </Grid>    

      <Grid container spacing={2} sx={{ marginTop: '10px' }}>
        <Grid size={12}>
          <Paper>
              <CercadorMovimentsGlobal />
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
};

export default CercadorMovimentsGlobalPage;
